import React from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { EventSystem } from '@emyw/core-lib';
import EnterPinForm from '../EnterPinForm';
import UpdatePinForm from '../UpdatePinForm';
import { isAuthenticated } from '../utils';
const ROUTE_CHECK_PIN_EXPIRES_AFTER_SECS = 60;

/** Can be used to setup private routes ensuring only authenticated users can access specified routes. */
class PrivateRoute extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      status: 'initializing',
      forgotPinModalOpen: window.location.search.includes('forgotpin'),
      pinExpiresAt: null
    };
    this.handleProfileChanged = () => {
      log.trace('got profile change event');
      // if (checkPin
      // this.setState({ status: 'needpin', pinExpiresAt: null });
      this.checkAccess();
    };
    this.checkAccess = async () => {
      // Takes into account authentication token and remember me cookies if not auth token found.
      const res = await isAuthenticated();
      const {
        checkPin
      } = this.props;
      const {
        pinExpiresAt
      } = this.state;
      let status = res ? 'authorized' : 'denied';
      // if this private route also checks pins, then do that here
      if (status === 'authorized' && checkPin && (!pinExpiresAt || pinExpiresAt < new Date())) {
        // console.log('pin expired or not entered yet. Prompting', this.pinExpiresAt);
        status = 'needpin';
      }
      this.setState({
        status
      });
    };
    this.handlePinEntered = () => {
      const pinExpiresAt = new Date();
      pinExpiresAt.setSeconds(pinExpiresAt.getSeconds() + ROUTE_CHECK_PIN_EXPIRES_AFTER_SECS);
      this.setState({
        status: 'authorized',
        pinExpiresAt
      });
    };
    this.handleForgotPin = () => {
      this.setState({
        forgotPinModalOpen: true
      });
    };
    this.handleForgonPinClose = () => {
      if (window.location.search.includes('forgotpin')) {
        // redirect to home page
        window.location.href = '/';
      } else {
        this.setState({
          forgotPinModalOpen: false
        });
      }
    };
  }
  componentDidMount() {
    this.checkAccess();
    EventSystem.subscribe('profileChanged', this.handleProfileChanged);
  }
  componentDidUpdate(prevProps) {
    const {
      checkPin,
      path
    } = this.props;
    if (checkPin && prevProps.path !== path) {
      this.checkAccess();
    }
  }
  componentWillUnmount() {
    EventSystem.unsubscribe('profileChanged', this.handleProfileChanged);
  }
  render() {
    var _location$pathname, _location$pathname2;
    const {
      status,
      forgotPinModalOpen
    } = this.state;
    const {
      location,
      history: {
        goBack
      },
      user
    } = this.props;
    let pinPrompt = null;
    if (((_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.indexOf('/manageaccount')) > -1) {
      pinPrompt = 'Manage Account is restricted';
    } else if (((_location$pathname2 = location.pathname) === null || _location$pathname2 === void 0 ? void 0 : _location$pathname2.indexOf('/manageprofiles')) > -1) {
      pinPrompt = 'Manage Profiles is restricted';
    }
    // let { status } = this.state;
    // status = 'needpin';
    log.trace('status', status);
    if (status === 'authorized') return /*#__PURE__*/React.createElement(Route, this.props);
    if (status === 'denied') {
      return /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: location
          }
        }
      }));
    }
    if (status === 'needpin') {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EnterPinForm, {
        onSuccessClose: this.handlePinEntered,
        onFailClose: goBack,
        onForgotPinClose: this.handleForgotPin,
        user: user,
        prompt: pinPrompt
      }), /*#__PURE__*/React.createElement(UpdatePinForm, {
        open: forgotPinModalOpen,
        onExit: this.handleForgonPinClose,
        user: user,
        forgotPinMode: true
      }));
    }
    return null;
  }
}
export default withRouter(PrivateRoute);